export enum PermissionAssignmentName {
  USER_CREATE_USER = 'user/create_user',
  ACRE_ORGANISATION_CREATE_REG_ORG = 'acre/organisation/create_reg_org',
  ORGANISATION_CREATE_AR_ORG = 'organisation/create_ar_org',
  ORGANISATION_CREATE_SUBDIVISION_ORG = 'organisation/create_subdivision_org',
  ORGANISATION_EDIT_ORG = 'organisation/edit_org',
  ORGANISATION_EDIT_ORG_FINANCIAL_CONFIGURATION = 'finance/edit_organisation_financial_configuration',
  ORGANISATION_EDIT_METADATA = 'organisation/edit_metadata',
  ORGANISATION_EDIT_SYSTEM_METADATA = 'organisation/edit_system_metadata',
  ORGANISATION_EDIT_FEES = 'organisation/edit_fees',
  ORGANISATION_REPORTING = 'organisation/reporting',
  ORGANISATION_VIEW_ORG_FINANCIAL_CONFIGURATION = 'finance/view_organisation_financial_configuration',
  PERMISSIONS_VIEW_PERMISSIONS = 'permissions/view_permissions',
  USER_VIEW = 'user/view',
  USER_EDIT_USER = 'user/edit_user',
  USER_EDIT_FEES = 'user/edit_fees',
  USER_EDIT_AUTHENTICATION = 'user/edit_authentication',
  USER_EDIT_USER_METADATA = 'user/edit_user_metadata',
  USER_EDIT_SYSTEM_METADATA = 'user/edit_system_metadata',
  USER_EDIT_ORG_DATA = 'user/edit_org_data',
  ORGANISATION_VIEW = 'organisation/view',
  ORGANISATION_EDIT_PROTECTED = 'organisation/edit_protected',
  ORGANISATION_CREATE_INTRODUCER_ORG = 'organisation/create_introducer_org',
  USER_VIEW_FEES = 'user/view_fees',
  CLIENT_VIEW_CLIENT = 'client/view_client',
  CLIENT_VIEW_PROTECTED = 'client/view_protected',
  CLIENT_EDIT_CLIENT = 'client/edit_client',
  CLIENT_EDIT_CLIENT_RESTRICTED = 'client/edit_client_restricted',
  CASE_CHANGE_OWNER = 'case/change_owner',
  CASE_VIEW_CASE = 'case/view_case',
  CASE_EDIT_CASE = 'case/edit_case',
  CASE_CREATE_ON_BEHALF_OF = 'case/create_on_behalf_of',
  GROUP_VIEW_GROUP = 'group/view_group',
  GROUP_EDIT_GROUP = 'group/edit_group',
  ACRE_ROLE_EDIT_ROLES = 'acre/role/edit_roles',
  ACRE_PERMISSIONS_EDIT_ROLES_PERMISSION_ASSIGNMENTS = 'acre/permissions/edit_roles_permission_assignments',
  PERMISSIONS_EDIT_REGULATED_PERMISSION = 'permissions/edit_regulated_permission',
  PERMISSIONS_EDIT_PERMISSION = 'permissions/edit_permission',
  PERMISSIONS_EDIT_ACRE_PERMISSIONS = 'permissions/edit_acre_permissions',
  CLIENT_VIEW_MORTGAGE = 'client/view_mortgage',
  CLIENT_VIEW_PROTECTION_INSURANCE = 'client/view_protection_insurance',
  REGULATED_MORTGAGE_PROVISIONAL = 'regulated/mortgageprovisional',
  REGULATED_MORTGAGE = 'regulated/mortgage',
  REGULATED_EQUITYRELEASE_PROVISIONAL = 'regulated/equityreleaseprovisional',
  REGULATED_EQUITYRELEASE = 'regulated/equityrelease',
  REGULATED_PROTECTIONINSURANCE_PROVISIONAL = 'regulated/protectioninsuranceadvisedprovisional',
  REGULATED_PROTECTIONINSURANCE = 'regulated/protectioninsuranceadvised',
  REGULATED_GENERALINSURANCE_PROVISIONAL = 'regulated/generalinsuranceprovisional',
  REGULATED_GENERALINSURANCE = 'regulated/generalinsurance',
  REGULATED_COMPLIANCE_VIEWCOMPLIANCEDASHBOARD = 'regulated/viewcompliancedashboard',
  REGULATED_COMPLIANCE_VIEWCASEDETAIL = 'regulated/compliance/viewcasedetail',
  REGULATED_COMPLIANCE_APPROVECASES = 'regulated/compliance/approvecases',
  REGULATED_COMPLIANCE_APPROVEADVICE = 'regulated/compliance/approveadvice',
  REGULATED_COMPLIANCE_APPROVEEIDVOVERRIDE = 'regulated/compliance/approveeidvoverride',
  REGULATED_COMPLIANCE_APPROVEAML = 'regulated/compliance/approveaml',
  REGULATED_COMPLIANCE_ADDCASENOTES = 'regulated/compliance/addcasenotes',
  REGULATED_COMPLIANCE_VIEWCASENOTES = 'regulated/compliance/viewcasenotes',
  REGULATED_COMPLIANCE_USERMANAGEMENT = 'regulated/compliance/usermanagement',
  REGULATED_DEBTCONSOLIDATION = 'regulated/debtconsolidation',
  FIRM_MANAGETEMPLATES = 'firm/managetemplates',
  ACCOUNTING = 'finance/view_case_ledger',
  DELETE_LEDGER = 'finance/delete_ledger',
  CREATE_CASE_LEDGER = 'finance/create_case_ledger',
  EDIT_CASE_LEDGER = 'finance/edit_case_ledger',
  WRITE_OFF_LEDGER = 'finance/write_off_amounts_due',
  VIEW_UNLINKED_PAYMENTS_LEDGER = 'finance/view_unlinked_payments',
  APPLY_PAYMENT_LEDGER = 'finance/apply_payment',
  EDIT_UNLINKED_PAYMENTS_LEDGER = 'finance/edit_unlinked_payments',
  VIEW_PROVIDER_STATEMENT = 'finance/view_provider_statements',
  EDIT_PROVIDER_STATEMENT = 'finance/edit_provider_statements',
  INVALID_PERMISSION_ASSIGNMENT_NAME = 'permissions/invalid-permission',
  MANAGE_ORGANISATION = 'organisation/manage_organisation',
  ACRE_CASE_IMPORT = 'acre/case_import',
  REFERRAL_PARTNERS = 'organisation/referral_partners',
}

export type PermissionScopeType = 'organisation' | 'case' | 'client' | 'user'

export interface EntityIdsCollection extends Partial<Record<PermissionScopeType, string[]>> {
  organisation?: string[]
  user?: string[]
  case?: string[]
  client?: string[]
}
